$(function() {
  /**
   * アラート表示の文言
   */
  const alertModalText = {
    addCart: {
      title: "カートに追加しました",
      body: ""
    },
    addCartPartial: {
      title: "カートに追加できませんでした",
      body: "カートに追加できる上限数を超えているパーツが存在するため、この商品をカートに追加できませんでした。"
    },
    addLimit: {
      title: "商品カート追加上限",
      body: "この商品はこれ以上カートに追加することはできません。"
    },
    soldOut: {
      title: "カートに追加できませんでした",
      body: "申し訳ございません。この商品は売り切れになった可能性があります。"
    },
    contradictBundleKey: {
      title: "カートにすでに商品が入っています",
      body: "この商品は別の商品と同時に購入したり、同じ商品でも同時に複数セット購入することができません。<br>お手数ですが、カートの中身の購入を済ませるか、カートの中身を削除してからこの商品を追加してください。"
    },
  }

  /**
   * 初期処理
   *
   * InfiniteOptions側でオプションに紐づくバリエーションプロパティが
   * 準備できたかどうかを監視する
   */
  function observeInfiniteObject() {
    if (Shoppad.apps.infiniteoptions.hasOwnProperty('priceMod')
      && Shoppad.apps.infiniteoptions.priceMod.hasOwnProperty('variantOrdering')
      && Shoppad.apps.infiniteoptions.priceMod.variantOrdering.length > 0) {
      clearInterval(intervalId)
      setLinkedVariants()

      // onChangeイベントを設定
      $('input[name*="properties"]').on('change', (e) => {
        toggleCalculatingPrice(true);

        // バリエーション変更時の処理
        changeOptions(e.target)

        // setTimeoutを利用しないと、infiniteOptionsのスクリプト側で準備ができていない
        setTimeout(() => {
          // 在庫状況をオプション項目に反映
          applyStockStatusToOption()

          // 在庫状況表示を設定
          setStockStatus()

          // 金額表示を変更する
          totalPriceChange()
        }, 1000)
      })

      // setTimeoutを利用しないと、infiniteOptionsのスクリプト側で準備ができていない
      setTimeout(() => {
        // 在庫状況表示を設定
        setStockStatus()

        // 合計金額を設定
        totalPriceChange()

        // アンカーリンク先を設定する
        addAnchorLink()
      }, 1000)

      // 在庫状況をオプション項目に反映
      applyStockStatusToOption()

      // 各オプションごとにチェックを付け直す
      setInitialCheckedOption()

      // 数量変更
      // 数量は1固定とするため、このイベントは設定しない
      /**
      $('.selectNumWrap button').on('click', function(e) {
        e.preventDefault()
        changeQuantity($(this))
      })
      */

      // カート追加
      $('[name="addToCart"]').on('click', function(e) {
        e.preventDefault()
        addCart($(this))
      })
    }
  }
  const intervalId = setInterval(observeInfiniteObject, 100)


  /**
   * オプション項目に紐づくバリエーション情報のリスト
   * @type {*[]}
   */
  let linkedVariants = []

  /**
   * InfiniteOptionsで紐づけられているバリエーションのリストを生成する
   */
  function setLinkedVariants() {
    const optionVariantIds = Shoppad.apps.infiniteoptions.priceMod.variantOrdering.map(idName => idName.split('-')[1])
    linkedVariants = optionVariantIds.map((id) => {
      /** @var orderMadePartsVariants */
      const filtered = orderMadePartsVariants.filter(variant => {
        return variant.id === parseInt(id)
      })
      return filtered[0]
    }).filter(v => v)
    createProductImages()
  }

  /**
   * 画像要素を生成する
   */
  function createProductImages() {
    // メイン画像
    linkedVariants.forEach(variant => {
      const mainImage = $("<img>", {
        src: variant.featured_image ? variant.featured_image?.src : variant.product_image,
        alt: variant.name,
      })
      $(".products_img-main").append($("<div>", { addClass: "products_img-item products_img-item-main" }).append(mainImage))
    })

    // サムネイル画像
    linkedVariants.forEach(variant => {
      const thumbImage = $("<img>", {
        src: variant.featured_image ? variant.featured_image?.src : variant.product_image,
        alt: variant.name,
      })
      $(".products_img-thumb").append($("<div>", { addClass: "products_img-item products_img-item-thumbnail" }).append(thumbImage))
    })

    slickSliderSetting()
  }

  /**
   * Slick Sliderの設定
   */
  function slickSliderSetting() {
    // 監視する範囲を指定
    const targetNode1 = document.getElementById('product-thumb-box')
    const targetNode2 = document.getElementById('product-main-img-box')
    // オプションを設定
    const config = { childList: true, subtree: true }

    // Mutation Observerの作成（サムネイルスクロール用）
    const IMG_HEIGHT = 56 // サムネイル高さ
    const observer1 = new MutationObserver(function (mutationsList, observer1) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // 追加されたノードをチェック
          for (let node of mutation.addedNodes) {
            if ($(node).is('.slick-list')) {
              // 監視を終了する
              observer1.disconnect()
              // サムネイル枚数判定
              let h1 = $('#product-thumb-box').height()
              let h2 = $('#product-thumb-box > .slick-list').height()
              if (h2 <= h1) {
                // スクロールボタン表示
                $('#thumb-scroll-down').addClass('not-exist')
                $('#thumb-scroll-up').addClass('not-exist')
              }

              // サムネイルスクロール
              let scroll_value = 0;
              // 次へ
              $('#thumb-scroll-down').on('click', function() {
                let scroll_curr = $('#product-thumb-box').scrollTop()
                let scroll_mod = scroll_curr >= IMG_HEIGHT ? scroll_curr % IMG_HEIGHT : scroll_curr
                if (scroll_mod === 0) {
                  scroll_value = scroll_curr + IMG_HEIGHT
                }
                else {
                  scroll_value = scroll_curr + (IMG_HEIGHT - scroll_mod)
                }
                $('#product-thumb-box').animate({
                  scrollTop: scroll_value
                }, 500, 'swing')
                return false
              });
              // 前へ
              $('#thumb-scroll-up').on('click', function() {
                let scroll_curr = $('#product-thumb-box').scrollTop()
                let scroll_mod = scroll_curr >= IMG_HEIGHT ? scroll_curr % IMG_HEIGHT : scroll_curr
                if (scroll_mod === 0) {
                  scroll_value = scroll_curr - IMG_HEIGHT
                }
                else {
                  scroll_value = scroll_curr - scroll_mod
                }
                $('#product-thumb-box').animate({
                  scrollTop: scroll_value
                }, 500, 'swing')
                return false
              });
            }
          }
        }
      }
    });

    // Mutation Observerの作成（メイン画像用）
    const observer2 = new MutationObserver(function (mutationsList, observer2) {
      for (let mutation of mutationsList) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // 追加されたノードをチェック
          for (let node of mutation.addedNodes) {
            if ($(node).is('.slick-dots')) {
              // 監視を終了する
              observer2.disconnect()
              // ページ数表示
              $('.slick-dots > li').each(function(idx, obj) {
                if (idx === 0) {
                  let ary = $(obj).html().match(/aria-label="([^"]*)"/)
                  let page_text = ary[1].replace('of', '/')
                  $('#product-main-img-page-no').html(page_text)
                  $(node).css('display','none')
                }
              })

              // 画像スライドでページ数変更
              // 次へ
              $('#product-main-img-box .slick-next').on('click', function() {
                imageSlideButton()
              });
              // 前へ
              $('#product-main-img-box .slick-prev').on('click', function() {
                imageSlideButton()
              });
              // スライダードラッグ
              let is_select = false
              let is_drag = false
              // ドラッグ開始
              $('#product-main-img-box').on('touchstart mousedown', function() {
                is_select = true
              });
              // ドラッグ中
              $('#product-main-img-box').on('touchmove mousemove', function() {
                if (is_select === true && is_drag === false) {
                  is_drag = true
                }
              });
              // ドラッグ完了
              $('#product-main-img-box').on('touchend mouseup mouseleave', function() {
                is_select = false
                if (is_drag === true) {
                  imageSlideButton()
                }
                is_drag = false
              });
            }
          }
        }
      }
    });

    // Mutation Observerを開始
    observer1.observe(targetNode1, config)
    observer2.observe(targetNode2, config)

    // slick slider main
    $(".products_img-main").slick({
      infinite: false,
      arrows: false,
      draggable: false,
      fade: true,
      asNavFor: ".products_img-thumb",
      initialSlide: sliderStartOffset, // liquid側で定義済み
      responsive:[{
        breakpoint: 960,
        settings: {
          infinite: true,
          arrows: true,
          draggable: true,
          dots: true,
          asNavFor: null,
        }
      }]
    })

    // slick slider thumbnail
    $(".products_img-thumb").slick({
      infinite: false,
      arrows: false,
      draggable: false,
      variableWidth: true,
      initialSlide: sliderStartOffset,　// liquid側で定義済み
      asNavFor: ".products_img-main",
      focusOnSelect: true,
    })

    stickyImage('.products_img-main', '.sticky-image-container')
  }

  /**
   * 画像スライドでページ数変更
   */
  function imageSlideButton() {
    $('#product-main-img-box > ul > li').each(function(idx, obj) {
      if ($(obj).attr('class') === 'slick-active') {
        let ary = $(obj).html().match(/aria-label="([^"]*)"/)
        let page_text = ary[1].replace('of', '/')
        $('#product-main-img-page-no').html(page_text)
      }
    });
  }

  /**
   * バリエーションの画像を変更
   * @param targetVariant
   */
  function variantImageChange(targetVariant) {
    let mainImages = document.getElementsByClassName('products_img-item-main')
    let thumbnailImages = document.getElementsByClassName('products_img-item-thumbnail')
    let currentActiveElement = undefined
    let targetElement = undefined
    let currentClass = ''
    let currentStyleZIndex = ''
    let currentStyleOpacity = ''
    let currentAriaHidden = ''
    let currentTabIndex = ''
    let currentActiveThumbElement = ''
    let targetClass = ''
    let targetStyleZIndex = ''
    let targetStyleOpacity = ''
    let targetAriaHidden = ''
    let targetTabIndex = ''
    let targetActiveThumbElement = ''
    let activeThumbClass = 'products_img-item products_img-item-thumbnail slick-slide slick-current slick-active'
    let passiveThumbClass = 'products_img-item products_img-item-thumbnail slick-slide'
    const variantImage = targetVariant.featured_image ? targetVariant.featured_image?.src : targetVariant.product_image

    for (let mainElement of mainImages) {
      const image = mainElement.getElementsByTagName('img')[0]
      if (mainElement.getAttribute('aria-hidden') === 'false') {
        currentActiveElement = mainElement
        currentClass = mainElement.getAttribute('class')
        currentStyleZIndex = mainElement.style.zIndex
        currentStyleOpacity = mainElement.style.opacity
        currentAriaHidden = mainElement.getAttribute('aria-hidden')
        currentTabIndex = mainElement.getAttribute('tabindex')
      }
      if (image.getAttribute('src') === variantImage) {
        targetElement = mainElement
        targetClass = mainElement.getAttribute('class')
        targetStyleZIndex = mainElement.style.zIndex
        targetStyleOpacity = mainElement.style.opacity
        targetAriaHidden = mainElement.getAttribute('aria-hidden')
        targetTabIndex = mainElement.getAttribute('tabindex')
      }
    }

    for (let thumbElement of thumbnailImages) {
      const thumbImage = thumbElement.getElementsByTagName('img')[0]
      if (thumbElement.getAttribute('class') === activeThumbClass) {
        currentActiveThumbElement = thumbElement
      }
      if (thumbImage.getAttribute('src') === variantImage) {
        targetActiveThumbElement = thumbElement
      }
    }

    currentActiveElement.setAttribute('class', targetClass)
    currentActiveElement.style.zIndex = '998'
    currentActiveElement.style.opacity = '0'
    currentActiveElement.setAttribute('aria-hidden', targetAriaHidden)
    currentActiveElement.setAttribute('tabindex', targetTabIndex)
    currentActiveThumbElement.setAttribute('class', passiveThumbClass)
    targetElement.setAttribute('class', currentClass)
    targetElement.style.zIndex = '999'
    targetElement.style.opacity = '1'
    targetElement.setAttribute('aria-hidden', currentAriaHidden)
    targetElement.setAttribute('tabindex', currentTabIndex)
    targetActiveThumbElement.setAttribute('class', activeThumbClass)
  }

  /**
   * フッター追随の合計エリアの画像を変更
   * @param targetVariant
   */
  function estimateImageChange(targetVariant) {
    const estimateImage = document.querySelector('.order-made-estimate .estimate-image')
    estimateImage.src = targetVariant.featured_image ? targetVariant.featured_image?.src : targetVariant.product_image
  }

  /**
   * メイン画像を追従させる
   * @param fixedElem
   * @param fixedArea
   * @returns {null}
   */
  function stickyImage(fixedElem, fixedArea) {
    const areas = document.querySelectorAll(fixedArea)
    if (areas.length === 0) {
      return null
    }

    const checkFixed = (target, area) => {
      const startPosition = area.getBoundingClientRect().top - 144
      const targetHeight = target.clientHeight
      const areaHeight = area.clientHeight
      const endPosition = startPosition + areaHeight

      if (0 > startPosition && targetHeight < endPosition) {
        target.classList.add('is-fixed')
        target.style.top = '144px'
      }
      else if (0 <= startPosition) {
        target.classList.remove('is-fixed')
        target.style.top = ''
      }
      else {
        target.classList.remove('is-fixed')
        target.style.top = (areaHeight - targetHeight) + 'px'
      }
    }

    areas.forEach((area) => {
      const target = area.querySelector(fixedElem)
      if (target) {
        checkFixed(target, area)
        window.addEventListener('resize', () => {
          checkFixed(target, area)
        })
        window.addEventListener('scroll', () => {
          checkFixed(target, area)
        }, { passive: true })
      }
    })
  }

  /**
   * ページ内のコンテンツ（A+）にスクロールするリンクを設定する
   */
  function addAnchorLink() {
    const optionGroupNames = document.querySelectorAll("label.spb-productdescfont.spb-productdesctextcolor")
    optionGroupNames.forEach((optionGroupName) => {
      const variantList = getVariantsByOptionGroupName(optionGroupName.innerText)
      let anchor = ''
      for (let variant of variantList) {
        anchor = variant.anchor_link
        if (anchor) break
      }
      if (anchor) {
        const targetElem = document.getElementById(optionGroupName.id)
        const newElem = document.createElement('a')
        newElem.href = anchor
        newElem.className = 'anchor-icon'
        const iconElem = document.createElement('i')
        iconElem.className = "fa fa-link"
        newElem.appendChild(iconElem)
        targetElem.parentNode.insertBefore(newElem, targetElem)
      }
    })
    // スムーススクロール動作の設定
    const anchorLinks = document.querySelectorAll('a[href^="#"]')
    const anchorLinksArr = Array.prototype.slice.call(anchorLinks)
    anchorLinksArr.forEach((link) => {
      link.addEventListener('click', e => {
        e.preventDefault()
        const targetId = link.hash
        const targetElement = document.querySelector(targetId)
        const targetOffsetTop = window.pageYOffset + targetElement.getBoundingClientRect().top - 144
        window.scrollTo({
          top: targetOffsetTop,
          behavior: "smooth"
        })
      })
    })
    // 絶対パスのリンクはtarget=_blankで開く
    const httpLinks = document.querySelectorAll('a[href^="http"]')
    const httpLinksArr = Array.prototype.slice.call(httpLinks)
    httpLinksArr.forEach((link) => {
      link.setAttribute('target', '_blank')
    })
  }

  /**
   * オプショングループ名でバリエーションリスト（同一のプロダクト）を取得する
   * @param groupName
   * @returns {*[]}
   */
  function getVariantsByOptionGroupName(groupName) {
    const filtered = linkedVariants.filter(variant => variant.option_group_name === groupName)
    return filtered ?? []
  }

  /**
   * オプション名とオプショングループ名でバリエーションを取得する
   * @param groupName
   * @param name
   * @returns {*|null}
   */
  function getVariantByOptionName(groupName, name) {
    const filtered = linkedVariants.filter(variant => variant.option_group_name === groupName && variant.option_name === name)
    return filtered[0] ?? null
  }

  /**
   * 金額表示変更処理
   */
  function totalPriceChange() {
    let totalPrice = 0
    let compareAtPrice = 0
    let variantIds = []

    document.querySelectorAll('input[name*="properties"]').forEach((elm) => {
      if (elm.checked && !elm.disabled) {
        const optionGroupName = elm.name?.split('[')[1].split(']')[0]
        const optionName = elm.value
        if (!optionGroupName || !optionName) return

        const targetVariant = getVariantByOptionName(optionGroupName, optionName)
        if (!targetVariant) return

        totalPrice += targetVariant.price / 100
        if (targetVariant.compare_at_price) {
          compareAtPrice += targetVariant.compare_at_price / 100
        }
        variantIds.push(targetVariant.id)
      }
    })

    toggleCalculatingPrice(false);

    // 金額表示を反映
    $('.products-price .price').text(totalPrice.toLocaleString());
    $('.order-made-estimate .total-price').text(totalPrice.toLocaleString());

    //値下前価格があれば反映
    if ( compareAtPrice > 0 ){
      $(".products-price .discount").remove()
      $(".products-price").append('<span class="discount">' + compareAtPrice.toLocaleString() + '</span>')
    }
    else {
      $(".products-price .discount").remove()
    }

    // 獲得予定ポイントコンポーネントにvariantのidを渡す
    $('product-point').attr('variant-id', variantIds.join(','))
  }

  /**
   * オプション変更処理
   * @param targetOption
   */
  function changeOptions(targetOption) {
    const optionGroupName = targetOption.name?.split('[')[1].split(']')[0]
    const optionName = targetOption.value
    if (!optionGroupName || !optionName) return false

    const targetVariant = getVariantByOptionName(optionGroupName, optionName)
    if (!targetVariant) return false

    // メイン画像を変更する
    variantImageChange(targetVariant)
    // フッター固定の合計額表示欄の画像を変更する
    estimateImageChange(targetVariant)
  }

  /**
   * 在庫状況をオプション項目に反映する
   */
  function applyStockStatusToOption() {
    document.querySelectorAll('.order-made-variant input').forEach((elm) => {
      linkedVariants.forEach((variant) => {
        if (!variant.option_group_name || !variant.option_name) return
        const optionGroupName = `properties[${variant.option_group_name}]`
        const optionName = variant.option_name
        if (elm.name === optionGroupName && elm.value === optionName) {
          if (!variant.available) {
            elm.setAttribute('disabled', 'disabled')
          }
        }
      })
    })
  }

  /**
   * 各オプションごとに最初のavailableなオプションにチェックをつける
   */
  function setInitialCheckedOption() {
    document.querySelectorAll('.order-made-variant input').forEach((elm) => {
      const optionGroupName = elm.name?.split('[')[1].split(']')[0]
      const optionName = elm.value
      if (!optionGroupName || !optionName) return
      const targetVariant = getVariantByOptionName(optionGroupName, optionName)

      // variantと紐づいていない項目も初期チェックの対象にする
      // 有料項目が在庫切れで「注文しない」などが後続に存在するケースを考慮
      if (!targetVariant || targetVariant.available) {
        const targetElms = document.querySelectorAll(`input:checked[name="${elm.name}"]:not([disabled])`)
        if (targetElms.length === 0) {
          elm.checked = true
        }
      }
    })
  }

  /**
   * オプション項目に紐づくバリエーションの在庫状況に応じて、
   * 在庫状況ラベルやカート追加ボタンの状態を変更する
   */
  function setStockStatus() {
    // liquid側で定義されているproduct本体の販売状況がSOLD OUTなら以降の処理を行わない
    if (saleStatus === 'SoldOut') return

    // オプショングループ内の全ての項目がdisabledであれば、SOLD OUTにする
    const activeOptionName = Array.from(new Set(
      Array.from(document.querySelectorAll('input[name*="properties"]:not([disabled])')).map((elm) => elm.name)
    ))
    const disabledOptionName = Array.from(new Set(
      Array.from(document.querySelectorAll('input[name*="properties"]:disabled'))
        .filter((elm) => !elm.closest('.order-made-variant').hasAttribute('disabled'))
        .map((elm) => elm.name)
    ))
    let partiallyOutOfStock = false
    activeOptionName.concat(disabledOptionName).forEach((item) => {
      // この条件に該当する場合、各オプショングループ内の全ての在庫が切れている
      if (!activeOptionName.includes(item) && disabledOptionName.includes(item)) {
        partiallyOutOfStock = true
      }
    })

    if (partiallyOutOfStock) {
      // カート追加ボタン
      $('#cart-btn').prop('disabled', true)
      $('#cart-btn-text').text('SOLD OUT')
      $('#cart-btn-float').prop("disabled", true)
      $('#cart-btn-float-text').text('SOLD OUT')
      // 在庫状況ラベル
      $('#stock-status-label').html('SOLDOUT')
      $('#stock-status-label').removeClass('preorder')
      $('#stock-status-notes').addClass('not-exist')
    }
    else {
      // カート追加ボタン
      $('#cart-btn').prop('disabled', false)
      $('#cart-btn-text').text('カートに入れる')
      $('#cart-btn-float').prop("disabled", false)
      $('#cart-btn-float-text').text('カートに入れる')
      // 在庫状況ラベル
      $('#stock-status-label').html(initialStockStatusLabel)
      if (saleStatus === "onPreOrder") $('#stock-status-label').addClass('preorder')
      $('#stock-status-notes').removeClass('not-exist')
    }
  }

  /**
   * 数量変更処理
   * 選択されているオプションに紐づくバリエーションの最小在庫か、30個が購入上限
   *
   * @param target jQuery element
   */
  function changeQuantity(target) {
    let currentVal = $('input[name=quantity]').val()
    let minimum = 30

    document.querySelectorAll('input:checked[name*="properties"]:not([disabled])').forEach((elm) => {
      const optionGroupName = elm.name?.split('[')[1].split(']')[0]
      const optionName = elm.value
      if (!optionGroupName || !optionName) return
      const targetVariant = getVariantByOptionName(optionGroupName, optionName)
      if (!targetVariant) return

      if (isNumber(targetVariant.inventory_quantity) && parseInt(targetVariant.inventory_quantity) < minimum) {
        minimum = parseInt(targetVariant.inventory_quantity)
      }
    })

    let thisClass = target.attr('class')
    if (thisClass === "selectNum-minus") {
      currentVal--
      if (currentVal < 2) currentVal = 1
    }
    else {
      if (currentVal >= minimum) {
        $('#alert-title').html(alertModalText.addLimit.title)
        $('#alert-body').html(alertModalText.addLimit.body)
        $('#alert-modal').fadeIn()
        return
      }
      currentVal++
    }
    $('input[name=quantity]').val(currentVal)
  }

  /**
   * 数値かどうか
   *
   * @param val
   * @returns {boolean}
   */
  function isNumber(val){
    var regexp = new RegExp(/^[0-9]+(\.[0-9]+)?$/);
    return regexp.test(val);
  }

  /**
   * カート追加処理
   *
   * @param target jQuery element
   */
  function addCart(target) {
    if　(target.hasClass('different-bundle'))　{
      pdtShowBundlePopup()
    }
    else　{
      const quantity = $('[name="quantity"]').val()
      const addToCartData = { items: [] }
      const baseProductItem = { id: initialVariant.id, quantity: quantity, properties: {} }
      document.querySelectorAll('input:checked[name*="properties"]:not([disabled])').forEach((elm) => {
        const optionGroupName = elm.name?.split('[')[1].split(']')[0]
        const optionName = elm.value
        if (!optionGroupName || !optionName) return
        const targetVariant = getVariantByOptionName(optionGroupName, optionName)
        if (!targetVariant) return
        baseProductItem.properties[optionGroupName] = optionName
        addToCartData.items.unshift({ id: targetVariant.id, quantity: quantity })
      })
      addToCartData.items.push(baseProductItem)

      $.post({
        url:  '/cart/add.js',
        type: 'post',
        dataType: 'json',
        data: addToCartData,
      }).done((data, textStatus, jqXHR) => {
        pdtUpdateCartCount()
        $('#cart-btn').addClass('different-bundle')
        $('#cart-btn-float').addClass("different-bundle")
        $('#add-cart-title').html(alertModalText.addCart.title)
        $('#add-cart-body').html(alertModalText.addCart.body)
        $('#add-cart-modal').fadeIn()
      }).fail((jqXHR, textStatus, errorThrown) => {
        if (jqXHR.responseJSON.status === 422) {
          pdtUpdateCartCount(true)
          $('#add-cart-title').html(alertModalText.addCartPartial.title)
          $('#add-cart-body').html(alertModalText.addCartPartial.body)
          $('#add-cart-modal').fadeIn()
        }
        else {
          $('#alert-title').html(alertModalText.soldOut.title)
          $('#alert-body').html(alertModalText.soldOut.body)
          $('#alert-modal').fadeIn()
        }
      })
    }
  }

  /**
   * ヘッダーのカートアイコン部のカウントを更新
   * @param inputChange
   */
  function pdtUpdateCartCount(inputChange = false){
    $.getJSON("/cart.js")
      .done((json) => {
        const itemCount = json.item_count
        $(".ec_cart-num").text(itemCount)
        if (inputChange) {
          const inputItemCount = $('[name="quantity"]').val()
          if (inputItemCount > itemCount) {
            $('[name="quantity"]').val(itemCount);
          }
        }
      })
  }

  /**
   * bundle.keyが異なる場合のポップアップ
   */
  function pdtShowBundlePopup(){
    $('#alert-title').html(alertModalText.contradictBundleKey.title)
    $('#alert-body').html(alertModalText.contradictBundleKey.body)
    $('#alert-modal').fadeIn()
  }

  // 金額計算中のUI変更
  function toggleCalculatingPrice(isCalculating) {
    $('.products-price .price').toggleClass('price-caliculating', isCalculating)
    $('.estimate .total-price').toggleClass('price-caliculating', isCalculating)
  }

  /**
   * UIイベント処理
   */
  //シェアボタンクリック
  $('button.share').on('click', function (e) {
    e.preventDefault()
    $('#productsSharePopup').fadeIn()
  })

  //ポップアップ閉じる
  $('.products_notice_popup .close, .products_notice_popup .close_bottom').on('click', function (e) {
    e.preventDefault()
    $('.products_notice_popup').fadeOut()
  })

  // カート画面へ遷移する
  $('.products_notice_popup .to_cart').on('click', function (e) {
    e.preventDefault()
    location.href = '/cart'
    $('.products_notice_popup').fadeOut()
  })

  //レビュー一覧にスクロール
  $('.products-go-review').on('click', function (e) {
    e.preventDefault()
    const position = $('#AirReviews-BlockWrapper').offset().top - 180
    $('body,html').animate({ scrollTop: position }, 500, 'swing')
    return false
  })
})
